import CCOM from './CCOM';
import init from './init';
import { HLSPRM, DVBC } from '../../utils/playerConstants';

const smartcardId = getSmartCardId();

const multipleaudio = {};
// HLSPRM
multipleaudio.hlsprm = {};
multipleaudio.hlsprm.vod = true;
multipleaudio.hlsprm.live = false;
multipleaudio.hlsprm.timeshift = false;
// DVBC
multipleaudio.dvbc = {};
multipleaudio.dvbc.vod = false;
multipleaudio.dvbc.live = true;
multipleaudio.dvbc.timeshift = false;

const supported_stream_types = {};
supported_stream_types.vod = [HLSPRM];
supported_stream_types.live = [DVBC];
supported_stream_types.timeshift = [HLSPRM];

export default {
  appKey: '54324c4e36f45ca87786a77f722f21fd',
  appSubkey: 'generic',
  device_category: 'stb',
  device_id: smartcardId,
  device_manufacturer: 'nagra',
  device_model: 'nagra',
  device_name: 'nagra',
  device_so: 'opentv',
  device_type: 'stb',

  stream_type: 'hlsprm',
  smartcardId,
  init,

  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  useEpgPostals: true,
  // TODO put the correct akamai_id value
  akamai_id: 'Unknown',
  nodetv: 'nagratv',
  loadingFlow: 'smartcard',
  //akamai_mfwk: 'mfwkngv-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkngv-api.clarovideo.net' : 'http://mfwkngv-api.clarovideo.net'
};

function getSmartCardId() {
  const spaces = /\s/g;
  const smartcardInfo = CCOM.ConditionalAccess.getSmartcardInfo();

  if (smartcardInfo.error) {
    return '245705069313';
  }

  const { serialNumber } = smartcardInfo.smartcardInfo;
  return serialNumber.replace(spaces, '');
}



// WEBPACK FOOTER //
// ./src/devices/nagra/config.js